<div [id]="idModal" class="modal modal-filter fade modal-full-width modal-full-height" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Pesquisar Cliente
                </h4>                   
            </div>
            <div class="modal-body" #modalBody>
                <div class="row" *ngIf="filter">
                    <div class="col-12">
                        <sgt-cliente-filter
                            #clienteFilter
                            [filter]="filter"
                            [allowStorage]="false"
                            (filterInitialized)="onFilterInitialized()"
                            (filterChange)="onFilterChange()"
                            (filterCleaned)="onFilterCleaned()"
                            
                            [somenteClientesEmCarteira]="somenteClientesEmCarteira"
                            [somenteClientesEmCarteiraAtiva]="somenteClientesEmCarteiraAtiva"
                            [somenteClientesEmCarteiraInativa]="somenteClientesEmCarteiraInativa"
                            [somenteClientes]="somenteClientes"
                            [somenteClientesProspects]="somenteClientesProspects"
                            [somenteClientesCongelados]="somenteClientesCongelados"
                            [somenteClientesBloqueados]="somenteClientesBloqueados"
                            [somenteClientesBaixados]="somenteClientesBaixados"
                            [somenteClientesOutros]="somenteClientesOutros"
                            [cadastroProspect]="cadastroProspect"
                            [cadastroCliente]="cadastroCliente"
                            [cadastroBaixado]="cadastroBaixado"
                            [cadastroOutros]="cadastroOutros"

                            [somenteClientesAtivos]="somenteClientesAtivos"
                            [somenteClientesInativos]="somenteClientesInativos"
                            [situacaoNovo]="situacaoNovo"
                            [situacaoPositivo]="situacaoPositivo"
                            [situacaoAtivo]="situacaoAtivo"
                            [situacaoPreInativo]="situacaoPreInativo"
                            [situacaoInativo]="situacaoInativo"
                            [situacaoCongelado]="situacaoCongelado"
                            [situacaoBloqueado]="situacaoBloqueado"
                            [situacaoPreBaixado]="situacaoPreBaixado"
                            [situacaoBaixado]="situacaoBaixado"
                            [situacaoOutros]="situacaoOutros">
                        </sgt-cliente-filter>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped table-hover datatables table-clientes filter-modal" [id]="idDataTable">
                            <thead>
                                <tr>
                                    <th class="col-options"></th>
                                    <th class="col-codigo-integracao-erp">Código ERP</th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-nome-fantasia">Nome Fantasia</th>
                                    <th class="col-cnpj-cpf">CNPJ / CPF</th>
                                    <th class="col-nome-representante">Representante</th>
                                    <th class="col-cadastro text-center">Cadastro</th>
                                    <th class="col-situacao text-center">Situação</th>
                                </tr>
                            </thead>
                        </table>                     
                    </div>
                </div>                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>